module.exports = __webpack_public_path__ + "img/haze.9af9963e.jpg";